import React from 'react'
import { DayType } from '../constants/DayType'
import { DAY_TYPE_BORDER_COLORS, DAY_TYPE_COLORS } from '../constants/DayColors'

const ScheduleContextMenuDayBadge = ({
  dayType,
  searchQuery,
}: {
  dayType: DayType
  searchQuery?: string
}) => {
  const backgroundColor = DAY_TYPE_COLORS[dayType] ?? '#E7ECF0'
  const borderColor = DAY_TYPE_BORDER_COLORS[dayType] ?? '#D9D9D9'
  const dayTypeCode =
    dayType === DayType.NoContract ? '-' : (DayType[dayType] ?? '')

  const highlightText = (text: string, query: string | undefined) => {
    if (!query) return text

    const regex = new RegExp(`(${query})`, 'gi')
    const parts = text.split(regex)

    return parts.map((part, index) => {
      if (part.toLowerCase() === query.toLowerCase()) {
        return (
          <span key={index} className="tw-bg-yellow-200">
            {part}
          </span>
        )
      }
      return part
    })
  }

  return (
    <div
      className="tw-min-w-[40px] tw-max-w-fit tw-rounded-sm tw-border-l-[2px] tw-pl-1 tw-pr-2.5"
      style={{
        backgroundColor,
        borderLeftColor: borderColor,
      }}
    >
      <span className="tw-text-sm tw-font-semibold tw-text-content-base">
        {highlightText(dayTypeCode, searchQuery)}
      </span>
    </div>
  )
}

export default ScheduleContextMenuDayBadge
